import { SET_LOAN_DETAIL, SET_VENDOR } from './types'

export function setLoanDetail(data: any) {
  return { type: SET_LOAN_DETAIL, data }
}

export function setVendor(data: any) {
  return { type: SET_VENDOR, data }
}
